<template>
    <vx-expandable-card id="subscriptions">
        <template v-slot:header> Subscription Status </template>
        <template v-slot:headerSubtitle>
            The contact’s preference for the type of messages they wish to receive.
        </template>

        <template v-slot:content>
            <vx-icon-loading v-if="loadingSubscriptions" spin></vx-icon-loading>
            <div v-else class="flex flex-col gap-4 lg:gap-8 lg:grid lg:grid-cols-2">
                <div data-test="marketing-wrapper">
                    <vx-label>Marketing</vx-label>
                    <vx-radio-selection v-model="marketingStatus" :disabled="groupId && !onCorporate()">
                        <vx-radio-selection-item value="unknown" :disabled="existingMarketingStatus !== 'unknown'"
                            >No Preference</vx-radio-selection-item
                        >
                        <vx-radio-selection-item value="opt_in">Opt-in</vx-radio-selection-item>
                        <vx-radio-selection-item value="opt_out">Opt-out</vx-radio-selection-item>
                    </vx-radio-selection>
                </div>
                <div data-test="transactional-wrapper">
                    <vx-label>Transactional</vx-label>
                    <vx-radio-selection v-model="transactionalStatus" :disabled="groupId && !onCorporate()">
                        <vx-radio-selection-item value="unknown" :disabled="existingTransactionalStatus !== 'unknown'"
                            >No Preference</vx-radio-selection-item
                        >
                        <vx-radio-selection-item value="opt_in">Opt-in</vx-radio-selection-item>
                        <vx-radio-selection-item value="opt_out">Opt-out</vx-radio-selection-item>
                    </vx-radio-selection>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import {
    VxExpandableCard,
    VxIconLoading,
    VxLabel,
    VxRadioSelection,
    VxRadioSelectionItem,
} from '@voxie/frontend-components';
import { useContactDetails } from '../useContactDetails';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { onCorporate } = useCurrentGroup();

const {
    groupId,

    loadingSubscriptions,
    marketingStatus,
    transactionalStatus,
    existingMarketingStatus,
    existingTransactionalStatus,
} = useContactDetails();
</script>
